/**
 * Created by Lytov on 23.04.2020.
 */
import { makePrefixAdder } from '../utils/type-utils';

const addPrefixTo = makePrefixAdder('SECONDARY-NAV');
const SET_LINKS = addPrefixTo('SET_LINKS');

export const setSecondaryLinks = links => {
    return { type: SET_LINKS, payload: links };
};

const defaultState = {
    links: []
};

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
export function reducer(state = defaultState, action) {
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    switch (action.type) {
        case SET_LINKS:
            return {
                links: action.payload
            };
        default:
            return state;
    }
}

export const selector = state => state.secondaryNav.links;
